// extracted by mini-css-extract-plugin
module.exports = {"error-fallback":"_error-fallback_error-fallback__2Es_V","logo":"_error-fallback_logo__FjuXj","oops":"_error-fallback_oops__2PRdf"};